import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.user.as.view');
import { OnInit, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-afterservice-user-as-view',
template: templateSource || '',
    styles: [``],
})
export class PortalAfterserviceUserAsViewComponent implements OnInit, OnChanges {

    @ViewChild('modalMessage') modalMessage: any;
    @Input() postId!: string;

    public data: any = {};
    public statusView: '접수대기' | '진행' | '완료' | '' = '';

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes['postId'] && this.postId) {
            await this.load();
        }
    }

    private async showModal(message: string): Promise<void> {
        await this.modalMessage.open({ message });
    }

    async load() {

        const res = await wiz.call('view', { id: this.postId });

        if (res?.code !== 200) {
            this.router.navigate(['/user/as/list']);
            return;
        }

        this.data = res.data.post || {};
        this.initialize();

        await this.service.render();
    }

    private initialize() {

        this.statusView = this.data.status || '';

        if (this.data.installed) {
            this.data.installed =
                moment(this.data.installed).format('YYYY-MM-DD HH:mm');
        }

        if (this.statusView === '완료') {
            this.data.travel_fee = this.formatNumber(this.data.travel_fee);
            this.data.part_fee = this.formatNumber(this.data.part_fee);
            this.data.total_fee = this.formatNumber(this.data.total_fee);
        }
    }

    async deleteReport() {

        if (!this.data?.id) return;

        if (this.statusView !== '접수대기') {
            await this.showModal('접수대기 상태에서만 삭제할 수 있습니다.');
            return;
        }

        const confirmed = await this.modalMessage.open({
            title: 'A/S 접수 삭제',
            message: 'A/S 접수를 삭제하면 복원할 수 없습니다.\n정말 삭제하시겠습니까?',
            btnAction: '삭제',
            btnClose: '취소',
            btnClass: 'bg-[#cd201f] hover:bg-[#cd201f]/80 px-4 py-1.5 text-white'
        });

        if (!confirmed) return;

        const res = await wiz.call('delete', { id: this.data.id });

        if (res.code === 200) {

            await this.modalMessage.open({
                message: '삭제되었습니다.'
            });

            this.router.navigate(['/user/as/list']);
            return;
        }

        if (res.code === 403) {
            await this.showModal('접수대기 상태에서만 삭제할 수 있습니다.');
            return;
        }

        await this.showModal('삭제에 실패했습니다.');
    }

    formatNumber(value: any) {
        if (value === null || value === undefined) return '';
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    formatDate(date: any) {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD');
    }
}

export default PortalAfterserviceUserAsViewComponent;